// Admin-Überschreibungen der Portal-Texte (settings.portal_texts) – eigenes Mini-Modul, damit der LanguageProvider
// nicht das große Portal-Wörterbuch (portalTexts.js) ins Hauptbundle zieht.
let OVERRIDES = {};
export const setPortalTextOverrides = (o) => { OVERRIDES = o || {}; };
export const getPortalTextOverrides = () => OVERRIDES;
